module.exports = __webpack_public_path__ + "static/media/instagram.37b6c69a.png";